import type { Schedule } from '@reliance/types/models/Schedule';
import { useAsync } from 'react-async-hook';
import api from '../common/api';

export const useSchedulesByFacilityId = (facilityId: number | null | undefined) =>
  useAsync<Schedule[] | null>(
    async () => {
      if (facilityId == null || !Number.isFinite(facilityId)) {
        return null;
      }
      const response = await api.get<Schedule[]>('/schedule', { params: { facilityId } });
      return response.data;
    },
    [facilityId == null ? 'null' : String(facilityId)]
  );
